import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 查看选课活动公告
  getActivityAnnouncement(_postData) {
    return http.get(URL.API_ELECTIVE_ACTIVITY_ANNOUNCE, _postData)
  },
  // 查询学生端某个选课活动的可选选修班
  listEnableElectiveClass(_postData) {
    return http.get(URL.API_ELECTIVE_ACTIVITY_CLASS_ENABLE_LIST, _postData)
  },
  // 查看学生端选课活动
  listStudentEnableActivity(_postData) {
    return http.get(URL.API_ELECTIVE_ACTIVITY_ENABLE_LIST, _postData)
  },
  // 取消报名
  cancelEnterNameById(_postData) {
    return http.post(URL.API_ELECTIVE_CLASS_CANCEL, _postData)
  },
  // 取消报名2
  cancelEnterNameByUk(_postData) {
    return http.post(URL.API_ELECTIVE_CLASS_CANCELByUK, _postData)
  },
  // 选修班报名
  enterName(_postData) {
    return http.post(URL.API_ELECTIVE_CLASS_ENTERNAME, _postData)
  },
  // 查询学生的某个选修班详情
  getStudentElectiveClassDetail(_postData) {
    return http.get(URL.API_ELECTIVE_CLASS_DETAIL, _postData)
  },
  // 查询某选修班下的选课学生
  listElectiveClassStudent(_postData) {
    return http.get(URL.API_ELECTIVE_CLASS_STUDENT, _postData)
  },
  // 查询某个行政班下的学生的选修班情况
  listMajorClassStudentElectiveClass(_postData) {
    return http.get(URL.API_ELECTIVE_CLASS_STUDENT_LIST, _postData)
  },
  // 查询学生的选修班
  listStudentElectiveClass(_postData) {
    return http.get(URL.API_ELECTIVE_STUDENT_CLASS_LIST, _postData)
  },
  // 查询任课老师教的选修班
  listTeacherElectiveClass(_postData) {
    return http.get(URL.API_ELECTIVE_TEACHER_CLASS_LIST, _postData)
  },
  // 查询学生端某个选课活动的选修班类型
  listElectiveClassType(_postData) {
    return http.get(URL.API_ELECTIVE_CLASSTYPES, _postData)
  },
  // 统计某校区下的年级选修人数
  getElectiveCampusGradeStat(_postData) {
    return http.get(URL.API_ELECTIVE_CLASS_CAMPUS_GRADE_STAT, _postData)
  },
  // 统计某校区下的班级选修人数
  getElectiveGradeClassStat(_postData) {
    return http.get(URL.API_ELECTIVE_CLASS_GRADE_CLASS_STAT, _postData)
  }
}
